"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.jsonldDatasetProxy = void 0;
var ContextUtil_1 = require("./ContextUtil");
var ProxyCreator_1 = require("./ProxyCreator");
function jsonldDatasetProxy(inputDataset, context, entryNode) {
    var contextUtil = new ContextUtil_1.ContextUtil(context);
    var proxyCreator = new ProxyCreator_1.ProxyCreator();
    return proxyCreator.createSubjectProxy(entryNode, inputDataset, contextUtil);
}
exports.jsonldDatasetProxy = jsonldDatasetProxy;
